export default "__VITE_ASSET__b86307ec__"